import Tab from "components/Tabs/Tab";
import React, { useState, useEffect, useRef } from "react";

const tabs = [
  {
    name: "Scan",
    ref: "scan",
  },
  {
    name: "Storicità Annuncio",
    ref: "price",
  },
  {
    name: "Rendita Locativa",
    ref: "rental",
  },
  {
    name: "Location Intelligence",
    ref: "location",
  },
  {
    name: "Statistiche di Mercato",
    ref: "market-statistics",
  },
];

const PropertyTab = () => {
  const [activeTab, setActiveTab] = useState("Scan");
  const [isSticky, setIsSticky] = useState(false);
  const tabRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (tabRef.current) {
        const rect = tabRef.current.getBoundingClientRect();
        if (rect.top <= 80) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
      }

      // Get all section elements
      const sections = {
        scan: document.getElementById("scan-section"),
        price: document.getElementById("price-section"),
        rental: document.getElementById("rental-section"),
        location: document.getElementById("location-section"),
        "market-statistics": document.getElementById(
          "market-statistics-section"
        ),
      };

      // Check if we're at the bottom of the page
      const isAtBottom =
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 30;

      if (isAtBottom) {
        setActiveTab("Statistiche di Mercato");
        return;
      }

      // Find which section is currently in view
      const scrollPosition = window.scrollY + 200; // Add offset for better UX

      for (const [key, section] of Object.entries(sections)) {
        if (section) {
          const sectionTop = section.offsetTop;
          const sectionBottom = sectionTop + section.offsetHeight;

          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
            const tab = tabs.find((t) => t.ref === key);
            if (tab && tab.name !== activeTab) {
              setActiveTab(tab.name);
            }
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [activeTab]);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);

    // If Scan tab is clicked, scroll to top of the page
    if (tabName === "Scan") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      return;
    }

    // For other tabs, scroll to their respective sections
    const tab = tabs.find((t) => t.name === tabName);
    if (tab) {
      const section = document.getElementById(`${tab.ref}-section`);
      if (section) {
        const offset = 160; // Offset for header
        const targetScroll = section.offsetTop - offset;
        window.scrollTo({
          top: targetScroll,
          behavior: "smooth",
        });
      }
    }
  };

  return (
    <div
      ref={tabRef}
      className={`h-[60px] flex-col top-20 sticky bg-white hidden sm:flex  ${
        isSticky ? "sticky-custom-shadow-2 !z-[12]" : ""
      }`}
    >
      <div className="flex-1 px-5 md:px-0">
        <hr className="bg-[#AEAEAE4D] w-full" />
      </div>
      <Tab
        activeTab={activeTab}
        setActiveTab={handleTabClick}
        tabs={tabs}
        tabStyle={{
          borderColor: "#AEAEAE4D",
          fontWeight: "400",
          fontSize: "16px",
          color: "#00000096",
        }}
        tabUnderlineBackground="#1DA1F2"
        activeTabColor="#1DA1F2"
        tabButtonStyle={{ height: 42 }}
      />
    </div>
  );
};

export default PropertyTab;
